<div class="update-dialog">
  <div class="illustration">
    <button class="close-button" (click)="dismiss()">
      <app-icon name="close" size="24" colour="#6699DD"></app-icon>
    </button>
    <img src="assets/images/app-update.webp" alt="App Update" />
  </div>
  
  <div class="content">
    <h2>New version available</h2>
    
    <p class="description">
        {{ data.customMessage || 'We have introduced new features to make your journey simpler and more seamless.' }}
    </p>
    
  </div>

  <div class="modal-actions">
    <button class="tertiary full" (click)="dismiss()">
      Remind me later
    </button>
    <button class="primary full" (click)="updateNow()">
      {{ data.updateType === 'sideloaded' ? 'Go to Play Store' : 'Update now' }}
    </button>
  </div>
</div>